export const medicines = [
    {label: 'Paracetamol'},
    {label: 'Ibuprofen'},
    {label: 'Co-codamol'},
    {label: 'Codeine'},
    {label: 'Tramadol'},
    {label: 'Morphine'},
    {label: 'Diclofenac'},
    {label: 'Asprin'},
    {label: 'Naproxen'},
    {label: 'Dihydrocodeine'},
    {label: 'Oxycodone'},
    {label: 'Nefopam'},
    {label: 'Gabapentin'},
    {label: 'Fentanyl'},
    {label: 'Ketamine'},
    {label: 'Bisoprolol'},
    {label: 'Atenolol'},
    {label: 'Digoxin'},
    {label: 'Amiodarone'},
    {label: 'Adenosine'},
    {label: 'Diltiazem'},
    {label: 'Amoxicillin'},
    {label: 'Flucloxacillin'},
    {label: 'Meropenem'},
    {label: 'Vancomycin'},
    {label: 'Gentamycin'},
    {label: 'Clarithromycin'},
    {label: 'Co-amoxiclav'},
    {label: 'Doxycycline'},
    {label: 'Ceftazidime'},
    {label: 'Ciprofloxacin'},
    {label: 'Levofloxacin'},
  ];

  export const tests = [
    {label: 'ANA Test'},
    {label: 'Amylase Test'},
    {label: 'Biopsy'},
    {label: 'Blood Test'},
    {label: 'CBC'},
    {label: 'Colonoscopy'},
    {label: 'CRP Test'},
    {label: 'CT scan'},
    {label: 'Electrocardiogram'},
    {label: 'Electroencephalogram'},
    {label: 'Eye test'},
    {label: 'Gastroscopy'},
    {label: 'HbA1c'},
    {label: 'Hearing test'},
    {label: 'MRI scan'},
    {label: 'PET scan'},
    {label: 'Ultrasound'},
    {label: 'X-ray'},
  ];